export const COMMENTS = {
  COMMENT_INPUT_TEXT_AREA: 'comment-input-text-area',
  COMMENT_INPUT_WRAPPER: 'comment-input-wrapper',
  COMMENT_SEND_BUTTON_WRAPPER: 'comment-send-button-wrapper',
  COMMENT_SEND_BUTTON_ICON: 'comment-send-button-icon',
  COMMENT_MENTIONS_ICON_WRAPPER: 'comment-mentions-icon-wrapper',
  THREAD_INNER: 'thread-inner',
  MENTIONS_SUGGESTIONS_POPUP: 'mentions-suggestions-popup',
  MENTIONS_SUGGESTION_ITEM: 'mentions-suggestion-item',
  MENTIONS_SUGGESTION_AVATAR_WRAPPER: 'mentions-suggestion-avatar-wrapper',
  MENTIONS_SUGGESTION_EMAIL: 'mentions-suggestion-email',
  SAVED_COMMENT_TEXT: 'saved-comment-text',
  COMMENTBOX_COMMENT_SECTION: 'comment-box-comment-section',
  COMMENT_RESOLVE_TICK_ICON: 'comment-resolve-tick-icon',
  THREAD_USER_TIME: 'thread-user-time',
  REPLY_USER_TIME: 'reply-user-time',
  THREADS_POPUP_CONTAINER: 'threads-popup-container',
  THREADS_POPUP_NEW_THREAD_BTN: 'threads-popup-new-thread-btn',
  THREADS_POPUP_CLOSE_BTN: 'threads-popup-close-btn',
  THREADS_POPUP_BODY: 'threads-popup-body',
  THREAD_MORE_MENU_BTN: 'thread-more-menu-btn',
  THREAD_EDIT_FORM: 'thread-edit-form',
  THREAD_REPLIES_COUNT: 'thread-replies-count',
  THREAD_REPLY_BTN: 'thread-reply-btn',
  REPLY_CONTAINER: 'reply-container',
  REPLY_MORE_MENU_BTN: 'reply-more-menu-btn',
  REPLY_USER_NAME: 'reply-user-name',
  REPLY_COMMENT_TEXT: 'reply-comment-text',
  REPLY_EDIT_FORM: 'reply-edit-form',
  MORE_MENU_CONTAINER: 'more-menu-container',
  MORE_MENU_MARK_UNREAD: 'more-menu-mark-unread',
  MORE_MENU_EDIT_COMMENT: 'more-menu-edit-comment',
  MORE_MENU_COPY_LINK: 'more-menu-copy-link',
  MORE_MENU_DELETE: 'more-menu-delete',
  PROJECT_FEED_CONTAINER: 'project-feed-container',
  PROJECT_FEED_TITLE: 'project-feed-title',
  PROJECT_FEED_FILTER_BTN: 'project-feed-filter-btn',
  PROJECT_FEED_CLOSE_BTN: 'project-feed-close-btn',
  PROJECT_FEED_EMPTY_STATE: 'project-feed-empty-state',
  PROJECT_FEED_THREAD_LIST: 'project-feed-thread-list',
  PROJECT_FEED_FILTER_POPOVER: 'project-feed-filter-popover',
  PROJECT_FEED_ALL_COMMENTS_OPTION: 'project-feed-all-comments-option',
  PROJECT_FEED_COMMENTS_FOR_ME_OPTION: 'project-feed-comments-for-me-option',
  PROJECT_FEED_SHOW_ELEMENTS_WITH_COMMENTS: 'project-feed-show-elements-with-comments',
  PROJECT_FEED_RESOLVED_FILTER_POPOVER: 'project-feed-resolved-filter-popover',
  PROJECT_FEED_SHOW_RESOLVED_OPTION: 'project-feed-show-resolved-option',
  HOMEPAGE_COMMENTS_BTN: 'homepage-comments-btn',
  ORG_NOTIFICATIONS_FEED_CONTAINER: 'org-notifications-feed-container',
  ORG_NOTIFICATIONS_MARK_ALL_READ_BTN: 'org-notifications-mark-all-read-btn',
  ORG_NOTIFICATIONS_EMPTY_STATE: 'org-notifications-empty-state',
  USER_NOTIFICATION_CONTAINER: 'user-notification-container',
  USER_NOTIFICATION_USER_DP: 'user-notification-user-dp',
  USER_NOTIFICATION_USER_NAME: 'user-notification-user-name',
  USER_NOTIFICATION_TEXT: 'user-notification-text',
  USER_NOTIFICATION_TIME: 'user-notification-time',
  COMMENT_ONLY_BTN: 'comment-only-btn',
  TRACE_PATH_COMMENT_BTN: 'trace-path-comment-btn',
  TRACE_PATH_COMMENT_ICON: 'trace-path-comment-icon',
  COMMENT_BOX: 'comment-box',
  COMMENT_BTN: 'comment-btn',
  COMMENTS_NEW_ICON: 'comments-new-icon',
  GANTT_COMMENT_ICON: 'gantt-comment-icon',
  NOTES_WIDGET_CONTAINER: 'notes-widget-container',
  NOTES_WIDGET_TITLE_BAR: 'notes-widget-title-bar',
  NOTES_WIDGET_ACTIVITY_ID: 'notes-widget-activity-id',
  NOTES_WIDGET_TOGGLE_COMMENTS: 'notes-widget-toggle-comments',
  NOTES_WIDGET_EDITOR: 'notes-widget-editor',
  NOTES_WIDGET_COMMENTS_PANEL: 'notes-widget-comments-panel',
  NOTES_WIDGET_COMMENTS_FILTER_BTN: 'notes-widget-comments-filter-btn',
  NOTES_WIDGET_READ_ONLY_BANNER: 'notes-widget-read-only-banner',
  NOTES_CELL_EXPAND_BTN: 'notes-cell-expand-btn',
  TABLE_NOTES_CELL: 'table-notes-cell',
  GANTT_NOTES_CELL: 'gantt-notes-cell'
} as const;
